import {useFormik} from 'formik'
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import useBookings from '../../hooks/useBookings'
import {useParams} from 'react-router-dom'
import useClasses from '../../hooks/useClasses'

interface LocationOption {
  readonly value: string
  readonly label: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

export const locationOptions: readonly LocationOption[] = [
  {value: 'home', label: 'Home Module', isFixed: true, isDisabled: false},
  {value: 'audio', label: 'Audio Module', isFixed: true, isDisabled: false},
  {value: 'video', label: 'Video Module', isFixed: true, isDisabled: false},
]

const advertisementDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
})

const EditClasses = () => {
  const {id} = useParams()
  const [message, setMessage] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState(false)

  const [bookingFee, setBookingFee] = useState({
    description: '',
    name: '',
  })

  const [isPriorityError, setIsPriorityError] = useState(false)

  const {getClass, editClass} = useClasses()

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true)
        const {data, status} = await getClass(id as string)

        console.log(data, 'it is class')
        setBookingFee(data)
      } catch (error) {
        setError(true)
      } finally {
        setLoading(false)
      }
    }
    init()
  }, [])

  // Compressor

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: bookingFee?.name || '',
      description: bookingFee?.description || '',
    },

    validationSchema: advertisementDetailsSchema,
    onSubmit: async (values) => {
      try {
        setError(false)
        setLoading(true)

        await editClass(values, id as string)
        setMessage('Class updated successfully')
      } catch (error: any) {
        console.log(error, 'error ad')
        setError(true)
        setMessage(error.message)
      } finally {
        setLoading(false)
        setShowModal(true)
        //formik.resetForm()
      }
    },
  })

  console.log(formik.values, 'bookingFee')

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Edit Classes</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Name</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Name'
                    type='text'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Description</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <textarea
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Description'
                    {...formik.getFieldProps('description')}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.description}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              {/* <NavLink
           to='/apps/user-management/users'
           > */}
              <button type='submit' disabled={isLoading} className='btn btn-primary'>
                {!isLoading && 'Submit'}
                {isLoading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              {/* <button type='submit' className='btn btn-primary'>
                Submit
              </button> */}
              {/* </NavLink> */}
            </div>
          </form>
        </div>
        {showModal && (
          <MessageModal
            error={error}
            showModal={showModal}
            setShowModal={setShowModal}
            message={message}
            setError={setError}
            isPriorityError={isPriorityError}
            setIsPriorityError={setIsPriorityError}
          />
        )}
      </div>
    </>
  )
}
//@ts-ignore
const MessageModal = ({
  //@ts-ignore
  showModal,
  //@ts-ignore
  setShowModal,
  //@ts-ignore
  message,
  //@ts-ignore
  error,
  //@ts-ignore
  setError,
  //@ts-ignore
  isPriorityError,
  //@ts-ignore
  setIsPriorityError,
}) => {
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                      Close
                    </button> */}
                  <button
                    onClick={() => {
                      setShowModal(false)
                      if (!error) {
                        if (!isPriorityError) {
                          setIsPriorityError(false)
                          window.location.href = '/apps/classes'
                        }
                      }
                      setIsPriorityError(false)
                      setError(false)
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

//@ts-ignore
const Preview = ({file, setImgHeight, setImageWidth}) => {
  const [preview, setPreview] = useState(null)
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => {
    //@ts-ignore
    setPreview(reader.result)
    var img = new Image()
    //@ts-ignore
    img.src = reader.result
    img.onload = () => {
      setImgHeight(img.height)
      setImageWidth(img.width)
    }
  }
  return (
    <>
      <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
        {preview ? (
          <img
            style={{justifySelf: 'center', height: '300px', width: '300px'}}
            src={preview}
            alt='preview'
          />
        ) : (
          'loading..'
        )}
      </div>
    </>
  )
}

export default EditClasses
